import { UnitSimOperation } from "@/store/flowsheet/flowsheet.slice"
import { useEffect } from "react"
import { isNumber } from "lodash";
import { EventMap, getEventBusInstance } from "@/components/FlowSheetEditor/events/useEventBusInstance"
import { useReactState } from "@/components/FlowSheetEditor/hooks/useReactState"


export enum CellSimStatus {
  Unknow,
  Error,
  Warn,
  Success,
}

export function toCellSimStatus(status: number): CellSimStatus {
  if (!isNumber(status)) return CellSimStatus.Unknow
  if (status >= 500) {
    return CellSimStatus.Error
  } else if (status > 0) {
    return CellSimStatus.Warn
  } else {
    return CellSimStatus.Success
  }
}

export function statusToCellColor(status: CellSimStatus) {
  if (status === CellSimStatus.Error) {
    return '#ff0000'
  } else if (status === CellSimStatus.Warn) {
    return '#f2b202'
  }
  return '#222'
}
const statusClassMap = {
  [CellSimStatus.Error]: 'cell-sim-error',
  [CellSimStatus.Warn]: 'cell-sim-warn',
}

export function statusToCellClassName(status: CellSimStatus) {
  return statusClassMap[status] || ''
}

function getCellStatusClassName(id: string, changes: {[key: string]: UnitSimOperation}) {
  const opt = changes[id];
  if (opt) {
    const status = toCellSimStatus(opt.status)
    return statusToCellClassName(status)
  }

  return ''
}

export function useCellStatusClassName(id: string) {
  const nameState = useReactState('')

  useEffect(() => {
    const eventBus = getEventBusInstance()
    const handler = ({changes}) => {
      const name = getCellStatusClassName(id, changes)
      if (nameState.value !== name) {
        nameState.setValue(name)
      }
    }
    eventBus.on(EventMap.nodeSimStateChange, handler)

    return () => {
      eventBus.off(EventMap.nodeSimStateChange, handler)
    }
  }, [id, nameState])

  return nameState.value
}